import React, { memo } from "react";
import classNames from "classnames";
import linkifyHtml from "linkifyjs/html";

import styles from "./styles.module.scss";
import { GetImg } from "utils";

const MessengerCard: React.FunctionComponent<any> = ({
	user,
	data,
	sameMsgBlock = false,
}) => {
	const {
		sender: { name, id: userId, picture: avatar },
		timestamp: date,
		body: message,
	} = data;

	return (
		<div
			className={classNames(styles.container, {
				[styles.loggedUserMsg]:
					parseInt(userId) === parseInt(user.membership_id),
				[styles.sameMsgBlock]: sameMsgBlock,
			})}
		>
			<div
				className={classNames(styles.top, {
					[styles.reverseTop]:
						parseInt(userId) === parseInt(user.membership_id),
				})}
			>
				{parseInt(userId) !== parseInt(user.membership_id) ? (
					<>
						<div className={styles.leftSide}>
							{!sameMsgBlock && (
								<>
									<GetImg
										endpoint={avatar}
										className={styles.avatar}
										loadingSize={30}
									/>
									<div className={styles.userName}>
										{name}
									</div>
								</>
							)}
						</div>
						<div className={styles.rightSide}>{date}</div>
					</>
				) : (
					<>
						<div className={styles.rightSide}>{date}</div>
						<div className={styles.leftSide}>
							{!sameMsgBlock && (
								<>
									<GetImg
										endpoint={avatar}
										className={styles.avatar}
										loadingSize={30}
									/>
									<div className={styles.userName}>
										{name}
									</div>
								</>
							)}
						</div>
					</>
				)}
			</div>
			<div
				className={styles.bottom}
				style={{
					textAlign:
						parseInt(userId) !== parseInt(user.membership_id)
							? "left"
							: "right",
							paddingRight:'5px',
							paddingLeft:'5px',
							paddingTop: '5px'
				}}
				dangerouslySetInnerHTML={{
					__html: linkifyHtml(message),
				}}
			></div>
		</div>
	);
};

export default memo(MessengerCard);
